
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/database-internals",
      function () {
        return require("private-next-pages/books/database-internals.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/database-internals"])
      });
    }
  